export const MenuItems = [
    {
        title:'الصفحة الرئيسية',
        url:'home',
        cName:'nav__item',
        icon:'ri-home-5-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'المهارات',
        url:'skills',
        cName:'nav__item',
        icon:'ri-trophy-line',
        cNameLink:'nav__link',
        ActiveLink:'active-link',
    },
    {
        title:'خدمات',
        url:'services',
        cName:'nav__item',
        icon:'ri-briefcase-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'مشاريع',
        url:'projects',
        cName:'nav__item',
        icon:'ri-image-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'الاراء',
        url:'testimonial',
        cName:'nav__item',
        icon:'ri-question-answer-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
    {
        title:'التواصل معنا',
        url:'contact',
        cName:'nav__item',
        icon:'ri-chat-3-line',
        cNameLink:'nav__link',
        ActiveLink:'nav__link active-link',
    },
]